var $47dfaaac60bb350f$exports = {};
$47dfaaac60bb350f$exports = {
    "colorSwatchPicker": `Uzorci boje`,
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `Izaberite stavku`,
    "tableResizer": `Promena veli\u{10D}ine`
};


export {$47dfaaac60bb350f$exports as default};
//# sourceMappingURL=sr-SP.mjs.map
